<!--
 * @Descripttion: 分栏属性设置
 * @Author: zenghua.wang
 * @Date: 2021-04-14 11:20:58
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 14:58:00
-->
<template>
  <el-collapse
    v-model="collapse"
    accordion
  >
    <el-collapse-item
      name="1"
      :title="component.basic"
    >
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="分栏设置">
      <el-form-item label="排列方式">
        <el-radio
          v-model="data.option.direction"
          label="row"
        >横列</el-radio>
        <el-radio
          v-model="data.option.direction"
          label="column"
        >纵列</el-radio>
      </el-form-item>

      <template v-if="data.option.direction==='row'">
        <el-form-item label="左栏栅格">
          <el-input-number
            v-model="data.option.leftCol"
            :max="data.option.maxCol"
            :min="data.option.minCol"
            @change="setSpan($event, 'left')"
          />
        </el-form-item>

        <el-form-item label="右栏栅格">
          <el-input-number
            v-model="data.option.rightCol"
            :max="data.option.maxCol"
            :min="data.option.minCol"
            @change="setSpan($event, 'right')"
          />
        </el-form-item>
      </template>

      <el-form-item label="列间距(px)">
        <el-input-number v-model="data.option.gap" />
      </el-form-item>

      <el-form-item label="内边距(px)">
        <el-input-number v-model="data.option.padding" />
      </el-form-item>

      <el-form-item label="圆角(px)">
        <el-input-number v-model="data.option.borderRadius" />
      </el-form-item>

      <el-form-item label="背景色">
        <el-color-picker
          v-model="data.option.backgroundColor"
          :predefine="predefineColors"
        />
      </el-form-item>
    </el-collapse-item>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import { component, predefineColors } from '@/dragComponents/model/default.js'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-column',
  components: {
    configBase,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      component: component,
      predefineColors: predefineColors
    }
  },
  methods: {
    setSpan(val, flag) {
      this.data.option.leftCol = flag === 'left' ? val : 24 - val
      this.data.option.rightCol = flag === 'left' ? 24 - val : val
    }
  }
}
</script>
